export default __webpack_public_path__ + "static/media/wechat-open-with-browser.487f493c.jpg";